/* ============================================================
   AI Warehouse — storefront behaviour for the Horizon theme
   - Deal countdown timers
   - Wishlist hearts (localStorage, cosmetic — swap for an app later)

   Add-to-cart is handled natively by Horizon's <product-form-component>
   (see snippets/aiw-product-card.liquid), so there's no cart JS here.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Countdown timers ---------- */
  function tick(el) {
    var end = parseInt(el.dataset.end, 10);
    var diff = Math.max(0, end - Math.floor(Date.now() / 1000));
    var h = Math.floor(diff / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = diff % 60;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  function initTimers() {
    var els = document.querySelectorAll('[data-aiw-timer]');
    if (!els.length) return;
    els.forEach(tick);
    if (window.__aiwTimer) clearInterval(window.__aiwTimer);
    window.__aiwTimer = setInterval(function () { els.forEach(tick); }, 1000);
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var WKEY = 'aiw_wishlist';
  function readWish() {
    try { return JSON.parse(localStorage.getItem(WKEY)) || []; }
    catch (e) { return []; }
  }
  function writeWish(list) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
  }
  function paintWish() {
    var saved = readWish();
    document.querySelectorAll('[data-aiw-wish]').forEach(function (btn) {
      btn.classList.toggle('is-active', saved.indexOf(btn.dataset.aiwWish) !== -1);
    });
    document.querySelectorAll('[data-aiw-wish-count]').forEach(function (el) {
      el.textContent = saved.length;
      el.hidden = saved.length === 0;
    });
  }
  function initWishlist() {
    if (!window.__aiwWishBound) {
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-aiw-wish]');
        if (!btn) return;
        e.preventDefault();
        var id = btn.dataset.aiwWish;
        var saved = readWish();
        var i = saved.indexOf(id);
        if (i === -1) { saved.push(id); } else { saved.splice(i, 1); }
        writeWish(saved);
        paintWish();
      });
      window.__aiwWishBound = true;
    }
    paintWish();
  }

  function init() {
    initTimers();
    initWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run after Horizon re-renders sections in the Theme Editor.
  document.addEventListener('shopify:section:load', init);
})();
